import { useMutation } from '@tanstack/react-query';

import { REPORTING_LE_DATA_EXPORT_PATH } from '~/consts/reportingLeDataApi';

import { json_headers, request } from '~/services/common';

import { resolveReportingLeDataUrl } from '~/utils/resolveReportingLeDataUrl';

type ExportInput = {
  jobId: string;
  format?: 'csv' | 'jsonl';
};

type ExportResponse = {
  /** Domain-gated (@luxuryescapes.com) download link for the full result. */
  downloadUrl?: string;
  objectName?: string;
  rowCount?: number;
  format?: string;
};

/** Fetches a full-result download link for a truncated table block: le-data extracts the
 *  query's result to GCS and returns a domain-gated link, bypassing the LLM. */
export function useReportingLeDataExport() {
  return useMutation({
    mutationFn: async ({ jobId, format = 'csv' }: ExportInput) => {
      const url = resolveReportingLeDataUrl(REPORTING_LE_DATA_EXPORT_PATH);
      return (await request(url, {
        method: 'POST',
        headers: json_headers,
        body: JSON.stringify({ jobId, format }),
      })) as ExportResponse;
    },
  });
}
